import { createSelector } from 'reselect'
import selectUi from '../selector'

const selectLoading = createSelector(selectUi, state => state.loading)

export default selectLoading
